/* ============================================================
   Elementos dinámicos adicionales — theme-dynamic.js
   ============================================================ */
(function () {
  'use strict';

  /* ---- Tilt 3D en tarjetas de colección ---- */
  function initTilt() {
    var cards = document.querySelectorAll('.ml-tilt-card');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateX = ((y - centerY) / centerY) * -6;
        var rotateY = ((x - centerX) / centerX) * 6;
        card.style.transform = 'translateY(0) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale(1.015)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ---- Botones magnéticos ---- */
  function initMagnetic() {
    var els = document.querySelectorAll('.ml-hero__btn, .ml-nav__cta, .ml-add-btn, .cd-checkout-btn, .ml-nav__cart-btn');
    els.forEach(function (el) {
      el.classList.add('ml-magnetic');
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        el.style.transform = 'translate(' + (x * 0.25) + 'px, ' + (y * 0.25) + 'px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }

  /* ---- Partículas flotantes decorativas ---- */
  function initParticles() {
    var wrap = document.createElement('div');
    wrap.className = 'ml-particles';
    var count = window.innerWidth < 768 ? 12 : 28;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      p.className = 'ml-particle';
      p.style.left = (Math.random() * 100) + 'vw';
      p.style.animationDuration = (14 + Math.random() * 18) + 's';
      p.style.animationDelay = (Math.random() * 20) + 's';
      p.style.opacity = (0.15 + Math.random() * 0.35).toFixed(2);
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
  }

  /* ---- Contador animado para pills de "X posters" ---- */
  function initCounters() {
    if (!window.IntersectionObserver) return;
    var pills = document.querySelectorAll('[class*="ai-collections-grid__pill-"]');
    if (!pills.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var match = el.textContent.match(/(\d+)/);
        if (!match) return;
        var target = parseInt(match[1], 10);
        var suffix = el.textContent.replace(match[1], '').trim();
        var current = 0;
        var step = Math.max(1, Math.ceil(target / 20));
        el.classList.add('ml-counter');
        var timer = setInterval(function () {
          current += step;
          if (current >= target) { current = target; clearInterval(timer); }
          el.textContent = current + ' ' + suffix;
        }, 35);
        obs.unobserve(el);
      });
    }, { threshold: 0.4 });

    pills.forEach(function (p) { obs.observe(p); });
  }

  /* ---- Bootstrap ---- */
  function init() {
    initTilt();
    initMagnetic();
    initParticles();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
